import { render, staticRenderFns } from "./RuleList.vue?vue&type=template&id=d6916b68&scoped=true"
import script from "./RuleList.vue?vue&type=script&lang=js"
export * from "./RuleList.vue?vue&type=script&lang=js"
import style0 from "./RuleList.vue?vue&type=style&index=0&id=d6916b68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6916b68",
  null
  
)

export default component.exports